import { useState } from 'react';
import { 
  TransactionDrillDownData, 
  DrillDownEvolucaoComprasData, 
  DrillDownEvolucaoVendasData 
} from '../Components/DrillDown/types';

type DrillDownDataType = TransactionDrillDownData | DrillDownEvolucaoComprasData | DrillDownEvolucaoVendasData;

export const useTransactionDrillDown = (
  endpoint: string,
  transactionType: 'compras' | 'vendas',
  establishmentId?: number | string | null
) => {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [drillDownData, setDrillDownData] = useState<DrillDownDataType | null>(null);
  const [loading, setLoading] = useState(false);
  const [selectedPeriod, setSelectedPeriod] = useState<string | null>(null);

  const openModal = async (period: string) => {
    if (establishmentId === undefined || establishmentId === null || String(establishmentId).trim() === '') {
      console.warn('Estabelecimento não selecionado para abrir o drill down de transações.');
      return;
    }

    setSelectedPeriod(period);
    setIsModalOpen(true);
    setLoading(true);

    try {
      const baseUrl = process.env.REACT_APP_API_URL || '';
      const normalizedBaseUrl = baseUrl.endsWith('/') ? baseUrl : `${baseUrl}/`;
      const url = new URL(`sped-fiscal/${endpoint}`, normalizedBaseUrl);
      url.searchParams.set('periodo', period);
      url.searchParams.set('establishment_id', String(establishmentId));

      const headers: HeadersInit = {
        Accept: 'application/json',
        'Content-Type': 'application/json'
      };

      const token = document.cookie
        .split('; ')
        .find((row) => row.startsWith('authTokenMHP='))
        ?.split('=')[1];

      if (token) {
        headers['Authorization'] = `Bearer ${token}`;
      }

      const response = await fetch(url.toString(), { headers });

      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }

      const data = await response.json();
      
      // Adiciona o tipo de transação aos dados se não existir
      const normalizedData = {
        ...data,
        transactionType: transactionType
      };

      setDrillDownData(normalizedData);
    } catch (error) {
      console.error('Erro ao buscar detalhes do período:', error);
      setDrillDownData(null);
    } finally {
      setLoading(false);
    }
  };

  const closeModal = () => {
    setIsModalOpen(false);
    setSelectedPeriod(null);
    setDrillDownData(null);
  };

  return {
    isModalOpen,
    drillDownData,
    loading,
    selectedPeriod,
    openModal,
    closeModal,
    transactionType
  };
};

// Hook específico para compras (compatibilidade)
export const useEvolucaoComprasDrillDown = (endpoint: string, establishmentId?: number | string | null) => {
  return useTransactionDrillDown(endpoint, 'compras', establishmentId);
};

// Hook específico para vendas
export const useEvolucaoVendasDrillDown = (endpoint: string, establishmentId?: number | string | null) => {
  return useTransactionDrillDown(endpoint, 'vendas', establishmentId);
}; 